import { Navbar } from "react-bootstrap";

const NavBar = () => {
  return (
    <Navbar className="fixed-top navbar">
      <Navbar.Brand href="/" className="navbar__logo" />
      <h1 className="navbar__title text-uppercase">
        Habilitación de comercio e industria <br/>
        Solicitud de inscripción de remis y taxi
      </h1>
    </Navbar>
  );
};

export default NavBar;
